<template>
  <div>
    <el-form :model="post" :rules="rules" ref="annonceEdit">

        <ubi-page-container class="PostEdit">
            <template v-slot:page-tabs>
                <el-tabs v-model="currentTab" type="card" :before-leave="beforeLeavingTab">
                    <el-tab-pane v-for="tab in tabs"
                                 :key="tab.name"
                                 :label="tab.title"
                                 :name="tab.name"
                                 :disabled="tab.disabled"
                    >
                    </el-tab-pane>
                </el-tabs>
            </template>

            <template v-slot:page-actions>
                <el-row>
                    <el-dropdown @command="handleCommand" style="margin-right: 15px;">
                        <el-button type="primary" v-loading="loading">
                            {{ $t("posts.edit.save") }}...<em class="el-icon-arrow-down el-icon--right"></em>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="saveModifications" v-if="post.id">
                                {{ $t("posts.edit.saveModifications") }}
                            </el-dropdown-item>
                            <el-dropdown-item v-if="post.etat !== 'M' && currentType == null" command="diffuseNow">
                                {{ $t("posts.edit.diffuseNow") }}
                            </el-dropdown-item>
                            <el-dropdown-item command="saveDraft" v-if="currentType == null">
                                {{ $t("posts.edit.saveDraft") }}
                            </el-dropdown-item>
                            <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType == null && (post.nbDiffusions == 0)">
                                {{ $t("posts.edit.createModel") }}
                            </el-dropdown-item>
                            <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType == 'terrain'">
                                {{ $t("posts.edit.createAsLand") }}
                            </el-dropdown-item>
                            <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType == 'modele' && (post.nbDiffusions == 0)">
                                {{ $t("posts.edit.createModel") }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <el-button v-loading="loading" type="success" @click="modalDeleteModel = true"
                               v-if="post.etat === 'M' && !isSubUser">
                        <span @click="eventAnalytics('supprimer_modele')" v-if="currentType == 'terrain'">{{ $t("posts.edit.deleteLand") }}</span>
                        <span @click="eventAnalytics('supprimer_modele')" v-else>{{ $t("posts.edit.deleteModel") }}</span>
                    </el-button>

                    <el-button @click="$router.go(-1)">{{ $t("posts.edit.cancel") }}</el-button>
                </el-row>
            </template>

            <el-dialog
                    :title="$t('posts.dialog.modelDeleteTitle')"
                    :visible.sync="modalDeleteModel"
                    width="30%">
                <span>{{ $t("posts.dialog.modelDeleteText") }}</span>
                <span slot="footer" class="dialog-footer">
                <el-button @click="modalDeleteModel = false">{{ $t("posts.dialog.cancel") }}</el-button>
                <el-button type="primary" @click="deletePostModel(post.id)">{{ $t("posts.dialog.confirm") }}</el-button>
              </span>
            </el-dialog>

            <PostEditImmo v-if="this.universe === 'IMMO' && this.labelsLoaded && this.currentType== null" v-on:change-city-rule="changeCityRule" v-on:check-rules-surface="changeRulesSurface" :post="post" :create="create" :currentTab="currentTab" :redirect="redirect" :id-user="idUser" @change-redirect="changeRedirect"></PostEditImmo>

            <PostEditVo v-else-if="this.universe === 'VO' && this.labelsLoaded" :post="post" :create="create"
                        v-on:change-object-type-auto="changeObjectTypeAuto"
                        :currentTab="currentTab"
                        :id-user="idUser"
                        v-on:change_financement_type="changeFinancementType($event)"></PostEditVo>

            <CreateModelCmi v-if="this.universe === 'IMMO' && this.labelsLoaded && (this.currentType=='terrain' || this.currentType=='modele' || (this.isCmiste && post.etat == 'M'))" :post="post" :currentTab="currentTab"></CreateModelCmi>
            <template v-if="browserContext.up('md')">
                <hr/>
                <div class="text-right">
                    <el-row>
                        <el-dropdown @command="handleCommand" style="margin-right: 15px;">
                            <el-button type="primary" v-loading="loading">
                                {{ $t("posts.edit.save") }}...<em class="el-icon-arrow-down el-icon--right"></em>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="saveModifications" v-if="post.id">
                                    {{ $t("posts.edit.saveModifications") }}
                                </el-dropdown-item>
                                <el-dropdown-item v-if="post.etat !== 'M' && currentType == null" command="diffuseNow">
                                    {{ $t("posts.edit.diffuseNow") }}
                                </el-dropdown-item>
                                <el-dropdown-item command="saveDraft" v-if="currentType == null">
                                    {{ $t("posts.edit.saveDraft") }}
                                </el-dropdown-item>
                                <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType == null && (post.nbDiffusions == 0)">
                                    {{ $t("posts.edit.createModel") }}
                                </el-dropdown-item>
                                <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType == 'terrain'">
                                    {{ $t("posts.edit.createAsLand") }}
                                </el-dropdown-item>
                                <el-dropdown-item command="saveModel"  v-if="post.etat !== 'M' && currentType == 'modele' && (post.nbDiffusions == 0)">
                                    {{ $t("posts.edit.createModel") }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                        <el-button v-loading="loading" type="success" @click="modalDeleteModel = true"
                                   v-if="post.etat === 'M' && !isSubUser">
                            <span @click="eventAnalytics('supprimer_modele')" v-if="currentType == 'terrain'">{{ $t("posts.edit.deleteLand") }}</span>
                            <span @click="eventAnalytics('supprimer_modele')" v-else>{{ $t("posts.edit.deleteModel") }}</span>
                        </el-button>

                        <el-button @click="$router.go(-1)">{{ $t("posts.edit.cancel") }}</el-button>
                    </el-row>
                </div>
            </template>
        </ubi-page-container>
    </el-form>
    <ButtonScrollToTop @goToTop="goToTop" @scroll="handleScroll" v-if="buttonIsVisible"/>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

import { createPost, deleteModel, updatePost, getPostById, setAdsState, getPostByRef, addRuleSurface, checkMeuble } from '../../../services/posts'
import _findIndex from 'lodash/findIndex'

import { Tabs, TabPane } from 'element-ui'
import PostEditImmo from './PostEditImmo'
import PostEditVo from './PostEditVo'
import CreateModelCmi from './CreateModelCmi'
import ButtonScrollToTop from '@/components/ui/ButtonScrollToTop'
import { buttonScrollToTopMixin } from '@/mixins/buttonScrollToTopMixin'
import { getUsers } from '@/services/users'

export default {
  name: 'PostEdit',
  mixins: [buttonScrollToTopMixin],
  components: {
    ButtonScrollToTop,
    PostEditVo,
    PostEditImmo,
    CreateModelCmi,
    ElTabs: Tabs,
    ElTabPane: TabPane
  },
  inject: ['browserContext'],
  watch: {
    typeOffre: function (val) {
      const typeOffreTabIndex = _findIndex(this.tabs, function (o) {
        return o.name === 'detail'
      })
      if (!typeOffreTabIndex || !this.tabs[typeOffreTabIndex]) { return }
      if (val == 'L') {
        this.rules.prix[0].required = false
        this.rules.loyer_mensuel[0].required = true
      } else {
        this.rules.prix[0].required = true
        this.rules.loyer_mensuel[0].required = false
      }
      this.tabs[typeOffreTabIndex].disabled = !val
      this.$forceUpdate()
    },
    typeObjet: function (val) {
      const typeObjetTabIndex = _findIndex(this.tabs, function (o) {
        return o.name === 'description'
      })

      if (!typeObjetTabIndex || !this.tabs[typeObjetTabIndex]) { return }

      this.tabs[typeObjetTabIndex].disabled = !val
      // Si le client est CMISTE et qu'il choisit un terrain, on doit mettre le type d'offre à "V"
      if (this.isCmiste == true) {
        const typeOffreTabIndex = _findIndex(this.tabs, function (o) {
          return o.name === 'detail'
        })
        if (this.post.typeObjet == 1310) {
          this.post.typeOffre = 'V'
        } else {
          this.post.typeOffre = 'H'
        }
        if (val) {
          this.tabs[typeOffreTabIndex].disabled = !val
        }
      }
      this.$forceUpdate()
    }
  },
  data () {
    const checkReference = (rule, value, callback) => {
      const regexReference = RegExp('^[a-zA-Z0-9\\_\\-\\ \\.]+$')
      if (!(regexReference.test(value))) {
        return callback(new Error(this.$t('validator.referenceMustBeWithoutAccentAndSpecialCharacter')))
      }
      return callback()
    }
    const checkNumeroImmatriculation = (rule, value, callback) => {
      // Depuis 2009 les vehicules possédent des plaques format SIV (AA-999-BB),
      // avant ils avaient des plaques format FNI (1234 AB 35)
      // Depuis Octobre 2015 les "petit" cyclos (<=50 cm3) ont les mêmes numéros que les
      // autres vehicules (AA 999 AA) avant ils avait une plaque specifique (AA 345 A)

      const regexSIVVoiture = RegExp('^(?:[A-HJ-NP-TV-Z]{2}|WW|W)-?\\d{3}-?[A-HJ-NP-TV-Z]{2}$')
      const regexFNIVVoiture = RegExp('^[1-9][0-9]{0,3}(?:\\s|\.|-)?[A-HJ-NP-TV-Z]{1,3}(?:\\s|\.|-)?(?:[013-8][0-9]|2[0-9AB]|9[0-689ABCD]|97[0-9])$')
      const regexCyclo = RegExp('^[A-HJ-NP-TV-Z]{1,2}(?:\\s|\.|-)?\\d{3}(?:\\s|\.|-)?[A-HJ-NP-TV-Z]$')

      const valueOK = value !== '' && value !== undefined
      const millesimeOK = this.post.millesime !== '' && this.post.millesime !== undefined
      const typeObjetOK = this.post.typeObjet !== undefined

      const getDataImmat = async () => {
        const data = await this.checkImmat(value)
        return data
      }

      getDataImmat().then(
        data => {
          this.dataImmat = data
        }
      )

      // On limite la verif des plaques SIV à la France
      if (valueOK && millesimeOK && typeObjetOK && processEnvConfig.VUE_APP_PLATFORM === 'France') {
        value = value.toUpperCase()

        // check letters I and O
        if (value.includes('I') || value.includes('O')) {
          return callback(new Error(this.$t('validator.plate.letterIandOnotAllowed')))
        }

        // cyclo
        if (this.post.typeObjet >= 13000) {
          if (!(regexSIVVoiture.test(value) || (regexCyclo.test(value) && this.post.millesime > 2009) || (regexFNIVVoiture.test(value) && this.post.millesime <= 2009))) {
            return callback(new Error(this.$t('validator.plate.invalid')))
          }
        } else { // vehicules
          if (!regexSIVVoiture.test(value) && this.post.millesime > 2009) {
            return callback(new Error(this.$t('validator.plate.sivFormat')))
          } else if (!regexFNIVVoiture.test(value) && !regexSIVVoiture.test(value)) {
            return callback(new Error(this.$t('validator.plate.sivOrFniFormat')))
          }
        }
      }

      return callback()
    }
    const checkCylindree = (rule, value, callback) => {
      // basé sur les règles de ValidateurIntegrationAnnonceVo->valider_cylindree()
      // applique pour les motos et quad non électriques

      const electric = this.post.energie === 'électrique' || this.post.energie === 'eléctrico' ||
                    this.post.energie === 'electric'

      if ((this.post.typeObjet >= 13400 || this.post.typeObjet >= 14000) && !electric) {
        if (value === '' || value === undefined) {
          return callback(new Error('La cylindrée est obligatoire'))
        }
      }
      ;

      return callback()
    }

    return {
      create: false,
      loading: false,
      redirectToList: false,
      labelsLoaded: false,
      currentTab: 'main',
      currentType: null,
      modalDeleteModel: false,
      codeFlux: '',
      redirect: false,
      mandatoryCity: true,
      users: [],
      dataImmat: null,
      idUser: null,
      post: { communiquer_adresse_exacte: 'oui' },
      rules: {
        typeOffre: [{ required: true, message: this.$t('validator.offerTypeRequired'), trigger: 'blur' }],
        typeObjet: [{ required: true, message: this.$t('validator.propertyTypeRequired'), trigger: 'blur' }],
        reference: [{ required: false, validator: checkReference, trigger: 'blur' }],
        titre: [{ required: true, message: this.$t('validator.titleRequired'), trigger: 'blur' }],
        surface_habitable: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        prix: [
          { required: true, message: this.$t('validator.priceRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('validator.priceMustBeNumber') }
        ],
        prix_min: [
          { required: false, message: this.$t('validator.priceRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('validator.priceMustBeNumber') }
        ],
        loyer_mensuel: [
          { required: false, message: this.$t('validator.monthlyRentRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('validator.monthlyRentMustBeNumber') }
        ],
        afficher_prix: [{ required: true, message: this.$t('validator.showPriceRequired'), trigger: 'blur' }],
        texte: [
          { required: true, message: this.$t('validator.textRequired'), trigger: 'blur' },
          { min: 10, message: this.$t('validator.textAtLeast', { number: 10 }), trigger: 'blur' }
        ],
        localText: [
          { required: true, message: this.$t('validator.textRequired'), trigger: 'blur' },
          { min: 10, message: this.$t('validator.textAtLeast', { number: 10 }), trigger: 'blur' }
        ],
        honoraires_negociation: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        communiquer_adresse_exacte: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        code_postal: [{ required: true, message: this.$t('validator.postalCodeRequired'), trigger: 'blur' }],
        ville_reelle: [{ required: true, message: this.$t('validator.realCityRequired'), trigger: 'blur' }],
        code_postal_reel: [{ required: true, message: this.$t('validator.realPostalCodeRequired'), trigger: 'blur' }],
        ville_contact_a_afficher: [{ required: true, message: this.$t('validator.cityToShowRequired'), trigger: 'blur' }],
        champ_Nombre: [{ type: 'number', message: this.$t('validator.mustBeNumber') }],
        numero_immatriculation: [{ validator: checkNumeroImmatriculation, trigger: 'blur' }],
        numero_serie: [{ min: 17, max: 17, message: this.$t('validator.serialNumberAtLeast', { number: 17 }), trigger: 'blur' }],
        marque: [{ required: true, message: this.$t('validator.brandRequired'), trigger: 'blur' }],
        nb_pieces_logement: [{ required: false, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        financement_mensualites: [{ required: true, message: this.$t('validator.isRequired'), trigger: 'blur' }],
        modele: [{ required: true, message: this.$t('validator.modelRequired'), trigger: 'blur' }],
        modele_autre: [{ required: false, message: this.$t('validator.modelRequired'), trigger: 'blur' }],
        millesime: [{ required: true, message: this.$t('validator.yearRequired'), trigger: 'blur' }],
        version: [{ required: true, message: this.$t('validator.versionRequired'), trigger: 'blur' }],
        kilometrage: [{ required: true, message: this.$t('validator.mileageRequired'), trigger: 'blur' }],
        energie: [{ required: true, message: this.$t('validator.energyRequired'), trigger: 'blur' }],
        offre_titre: [{ max: 70, message: this.$t('validator.offerTitleMax', { number: 70 }), trigger: 'blur' }],
        cylindree: [{ validator: checkCylindree, trigger: 'blur' }]
      }
    }
  },
  methods: {
    ...mapMutations('posts', [
      'setPost'
    ]),
    ...mapMutations('postEditImmo', [
      'setAdManagerChanged',
      'SET_MEDIA_UPLOAD_DISABLED'
    ]),
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    async assignUser () {
      this.users = await getUsers()
      const userSelected = this.users.list.find(user => user.fullname === this.post.contact_a_afficher)
      if (userSelected) {
        this.post.id_contact_a_afficher = userSelected.id
        this.idUser = userSelected.id
        this.$store.commit('postEditImmo/setIdContactManagePost', userSelected.id)
      }
    },
    changeCityRule (payload) {
      this.rules.ville_reelle[0].required = payload.mandatoryCity
    },
    changeObjectTypeAuto (payload) {
      if (payload >= 16000) {
        this.rules.kilometrage[0].required = false
        this.rules.version[0].required = false
        this.rules.energie[0].required = false
        this.rules.cylindree[0].required = false
      } else {
        this.rules.kilometrage[0].required = true
        this.rules.version[0].required = true
        this.rules.energie[0].required = true
        this.rules.cylindree[0].required = true
      }
      if ((payload >= 13400) && (payload <= 13590)) {
        this.rules.modele_autre[0].required = true
      } else {
        this.rules.modele_autre[0].required = false
      }
    },
    async checkImmat (value) {
      const check = await this.$store.dispatch('postEditVo/checkCurrentImmatriculation', value)
      return check
    },
    changeRulesSurface (payload) {
      if (this.post.typeObjet >= 1300 && this.post.typeObjet < 1500) {
        delete (this.rules.nb_pieces_logement)
      }
      delete (this.rules.surface_habitable)
      delete (this.rules.surface_commerciale)
      delete (this.rules.surface_bureaux)
      delete (this.rules.surface_activite)
      delete (this.rules.surface_terrain)
      delete (this.rules.surface_stationnement)
      delete (this.rules.surface_min)

      this.rules = addRuleSurface(payload, this.rules)
    },
    changeRedirect (value) {
      this.redirect = value
    },
    async getPostsWithSameRef (reference) {
      const reponse = await getPostByRef(reference)
      return reponse
    },
    async onSubmit (etat = 'A') {
      this.post = checkMeuble(this.post)

      if (this.universe === 'VO') {
        if (this.dataImmat && this.dataImmat.object.total_items > 0 && this.post.id && this.post.id !== this.dataImmat.id) {
          this.$message.error(this.$t('validator.plate.alreadyExists'))
          return false
        } else if (this.dataImmat && this.dataImmat.object.total_items > 0 && this.create) {
          this.$message.error(this.$t('validator.plate.alreadyExists'))
          return false
        }
      }
      const checkIfRefExists = await getPostByRef(this.post.reference)

      this.$refs.annonceEdit.validate(async (valid) => {
        if (this.filter.annonceParente) {
          const annonceParente = await getPostById(this.filter.annonceParente)
          this.post.annonce_parente_reference = annonceParente.reference
        }
        if (this.post.etatAnnonce && this.post.etatAnnonce === 'Active') {
          this.post.STATUS = 'A'
        }
        if (this.post.communiquer_adresse_exacte == 'oui' && this.post.annonce_parente_reference == undefined && this.universe !== 'VO') {
          this.post.code_postal = this.post.code_postal_reel
          this.post.ville = this.post.ville_reelle
        }
        // Les champs "tva_prix_vente" et "prix_hors_taxe" doivent être supprimés pour éviter des soucis d'intégration coté sitimmo
        if (this.post.tva_prix_vente) {
          delete (this.post.tva_prix_vente)
        }
        if (!this.isCmiste && this.post.prix_hors_taxe) {
          delete (this.post.prix_hors_taxe)
        }
        // Gestion donnée prestige et standing
        if ((this.universe === 'IMMO') && (this.post.prestige == 'non')) {
          this.post.standing = ''
        }
        // #73119 tva_recuperable implique son contraire dans soumis_tva
        if (this.post.tva_recuperable) {
          this.post.soumis_tva = this.post.tva_recuperable == 'non' ? 'oui' : 'non'
        }
        // #75742 gestion type stationnement
        if ((this.post.garage === 'non') && (this.post.type_stationnement === 'garage')) {
          this.post.type_stationnement = ''
        }
        // Dans le cas d'un camping car nous avons "marque" et "marque_autre" et au moins un de ces deux champs doit être renseigné.
        let messageCampingCar = ''
        if (this.post.typeObjet >= 15000 && this.post.typeObjet <= 15300) {
          if ((this.post.marque == undefined || this.post.marque == '') && (this.post.marque_autre == undefined || this.post.marque_autre == '')) {
            // Si la marque n'est pas renseigné dans le champs "marque" ou "marque_autre" le formulaire est invalide.
            valid = false
            messageCampingCar = messageCampingCar + 'Remplissez au moins un champs "marque" \n'
          }
        }
        /**
         * On verifie que les informations obligatoires sont bien renseigné.
         * Si c'est le cas on envoie le formulaire en BDD
         */
        // Et on checke si la référence n'existe pas déjà
        if (valid) {
          // Si la référence dépasse 50 caractères, on affiche une erreur (en concordence avec la BDD)
          if (this.post.reference && this.post.reference.length > 50) {
            this.$message({ message: this.$t('validator.errorReferenceExceed'), type: 'error', duration: 5000 })
            this.loading = false
            return false
          }

          if (this.universe === 'IMMO') {
            this.codeFlux = 'SAISIE_IMMO'
          } else if (this.universe === 'VO') {
            this.codeFlux = 'SAISIE_VO'
            // En saisie VO le champ texte est généré en auto, réutiliser celui de l'API en modif pose probleme
            if (this.post.texte) {
              delete (this.post.texte)
            }
          }

          // we assign the user to the post if it isn't already and if we can identify the user (and if its not a model)
          if (etat !== 'M' && !this.post.user_data_code && !this.post.user_data_value && this.user.identifierCode && this.user.identifierValue) {
            this.post.user_data_code = this.user.identifierCode
            this.post.user_data_value = this.user.identifierValue
            this.post.user_data_change = true
            this.post.user_data_id = this.user.id
          } else if (etat === 'M') {
            // just in case if the current user assign the post to an other user and click on save as model
            this.post.user_data_code = null
            this.post.user_data_value = null
            this.post.STATUS = 'M'
          }

          let result = null
          if (this.create) {
            if (this.post.reference) {
              if (checkIfRefExists.total > 0) {
                this.$message({ message: this.$t('validator.referenceAlreadyExists'), type: 'error', duration: 5000 })
                this.loading = false
                return false
              }
              if (!this.post.reference) {
                this.$message({ message: this.$t('validator.enterReference'), type: 'error', duration: 5000 })
                this.loading = false
                return false
              }
            }
            this.loading = true
            if (etat) {
              this.post.STATUS = etat
            }
            result = await createPost(this.post, this.sitimmoLogin, this.codeFlux)

            if (result.type == 'error') {
              this.$message({ message: this.$t('error.found'), type: 'error', duration: 5000 })
              this.loading = false
              return false
            }
            this.post.id = result.ad.id
            this.create = false
          } else {
            this.loading = true
            result = await updatePost(this.post, this.sitimmoLogin, this.codeFlux)
            if (result.type == 'error') {
              this.$message({ message: this.$t('error.found'), type: 'error', duration: 5000 })
              this.loading = false
              return false
            }
          }
          if (this.hasMultiAccounts && !this.isSubUser) {
            this.setAdManagerChanged(true)
          }
          await setAdsState(result.ad.id, this.codeFlux, etat)
          this.post.etat = etat

          this.loading = false
          this.handleUpdateMessage(result)

          if (!this.redirectToList) {
            const currentTabIndex = _findIndex(this.tabs, function (o) {
              return o.name === this.currentTab
            }.bind(this))
            if ((currentTabIndex + 1) < this.tabs.length) {
              this.currentTab = this.tabs[currentTabIndex + 1].name
            }
            window.scrollTo(0, 0)
          } else {
            if (this.isCmiste && (this.currentType != null || this.post.etat == 'M')) {
              await this.$router.push({ name: 'content-library' })
            } else {
              if(this.post.etat == 'M') {
                console.log('SET FETCH MODELES')
                this.$store.commit('postsListImmo/SET_FETCH_MODELES', true)
              }
              await this.$router.push({ name: 'posts' })
            }
          }
        } else {
          this.redirectToList = false
          if (this.post.typeObjet >= 15000 && this.post.typeObjet <= 15300) {
            alert(this.$t('validator.alertMandatoryFields') + ' \n \n' + messageCampingCar)
          } else {
            alert(this.$t('validator.alertMandatoryFields'))
          }
          return false
        }
        if (this.hasMultiAccounts && !this.isSubUser) {
          this.setAdManagerChanged(false)
        }
      }
      , etat)
    },
    handleUpdateMessage (result) {
      if (result) {
        this.$message(result)
        // this.$router.go(-1)
      } else {
        this.$message({ message: this.$t('error.found'), type: 'error' })
      }
    },
    changeFinancementType (payload) {
      if (payload !== 'null') {
        this.post.financement_type = payload
      }
      switch (payload) {
        case 'null':
          this.rules.financement_mensualites[0].required = false
          this.rules.prix[0].required = true
          break
        case 'LOA':
          this.rules.financement_mensualites[0].required = true
          this.rules.prix[0].required = false
          break
        case 'LLD':
          this.rules.financement_mensualites[0].required = true
          this.rules.prix[0].required = false
          break
      }
    },
    formatPostBooleanValues (post) {
      const newPost = {}
      for (const property in post) {
        if (post[property] === true) {
          newPost[property] = 'oui'
        } else if (post[property] === false) {
          newPost[property] = 'non'
        } else {
          newPost[property] = post[property]
        }
      }
      this.post = newPost
    },
    async deletePostModel (id) {
      const call = deleteModel(id)
      if (call.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      this.modalDeleteModel = false
      this.redirectToList = true
      await this.$router.push({ name: 'posts' })
    },
    beforeLeavingTab (activeName, oldActiveName) {
      window.scrollTo(0, 0)
    },
    handleCommand (command) {
      this.redirectToList = true
      // @click="eventAnalytics('modifier')"
      if (command === 'saveModifications') {
        this.eventAnalytics('modifier')
        this.redirectToList = false
        if (this.post.etatAnnonce && this.post.etatAnnonce == 'Active') {
          this.onSubmit('A')
          this.post.STATUS = 'A'
        } else if (this.post.etatAnnonce && this.post.etatAnnonce == 'Modèle') {
          this.onSubmit('M')
          this.post.STATUS = 'M'
        } else {
          this.onSubmit('B')
          this.post.STATUS = 'B'
        }
      } else if (command === 'saveDraft') {
        this.eventAnalytics('creation_brouillon')
        this.onSubmit('B')
      } else if (command === 'saveModel') {
        this.eventAnalytics('creation_modele')
        this.onSubmit('M')
      } else if (command === 'diffuseNow') {
        this.eventAnalytics('enregistrer_diffuser')
        this.onSubmit()
      }
    }
  },
  computed: {
    ...mapState('posts', ['filter', 'tabs']),
    ...mapState('postEditVo', ['existingImmatriculation']),
    ...mapState('postEditImmo', ['adManagerChanged', 'mediaUploadDisabled']),
    ...mapGetters(['isSubUser', 'hasMultiAccounts']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    universe () {
      return this.sitimmoUser.univers
    },
    job () {
      return this.sitimmoUser.metier
    },
    sitimmoLogin () {
      return this.sitimmoUser.login
    },
    username () {
      return this.user.username
    },
    typeOffre () {
      return this.post.typeOffre
    },
    typeObjet () {
      return this.post.typeObjet
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    isUSH () {
      return this.user.isUSH
    },
    pageTitle () {
      if (this.isPromoteur || (this.isBailleurSocial && this.filter.creationProgramme)) {
        if (this.filter.annonceParente) {
          return this.$t('posts.edit.pageTitleLot')
        } else {
          return this.$t('posts.edit.pageTitleProgram')
        }
      }
      if (this.$route.name == 'model-edit') {
        return this.$t('posts.edit.pageTitleModele')
      }
      return this.$t('posts.edit.pageTitleAd')
    }
  },
  async beforeMount () {
    this.$route.meta.title = this.pageTitle
    if (!this.post.nbDiffusions) {
      this.post.nbDiffusions = 0
    }
    if (this.$route.params.type) {
      this.currentType = this.$route.params.type
      if (this.currentType === 'modele') {
        this.post.typeObjet = 1200
      }
      if (this.currentType === 'terrain') {
        this.post.typeObjet = 1310
      }
    }
    if (this.$route.params && this.$route.params.id) {
      this.create = false
      this.post = await getPostById(this.$route.params.id)
      if (this.post.contact_a_afficher) {
        this.assignUser()
      }

      if(this.post.emission && this.post.emission.picturesManagedBySeize) {
        this.SET_MEDIA_UPLOAD_DISABLED(false)
      }
      if (this.post.typeObjet >= 1300 && this.post.typeObjet < 1400) {
        delete (this.rules.surface_habitable)
      }
      if (typeof this.post.prix === 'string') {
        this.post.prix = parseInt(this.post.prix)
      }

      if (this.post.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      if (this.post.taux_tva === 5.5) {
        this.post.TVA_55 = 'oui'
      } else if (this.post.taux_tva === 7) {
        this.post.TVA_7 = 'oui'
      }
      if (this.isCmiste === true && this.post.etat === 'M') {
        if (this.post.typeObjet >= 1200 && this.post.typeObjet < 1300) {
          this.currentType = 'modele'
        } else if (this.post.typeObjet >= 1310 && this.post.typeObjet < 1400) {
          this.currentType = 'terrain'
        }
      }
      this.formatPostBooleanValues(this.post)
    } else {
      this.create = true
    }

    if (this.post.typeObjet >= 3000 && this.post.typeObjet < 4000 && this.isBailleurSocial) {
        this.$route.meta.title = this.$t('posts.edit.pageTitleProgram')
        this.rules.prix[0].required = false
        this.rules.prix_min[0].required = false
        this.rules.prix_max[0].required = false
        this.rules.code_postal[0].required = false
        this.rules.code_postal_reel[0].required = false
        this.rules.ville_reelle[0].required = false
        this.rules.ville_contact_a_afficher[0].required = false
        this.filter.creationProgramme = true
    }
    if (this.post.annonceParente && this.isBailleurSocial) {
        this.rules.prix[0].required = false
        this.rules.prix_min[0].required = false
        this.rules.prix_max[0].required = false
        this.rules.code_postal[0].required = false
        this.rules.code_postal_reel[0].required = false
        this.rules.ville_reelle[0].required = false
        this.rules.ville_contact_a_afficher[0].required = false
    }
    if (this.isPromoteur || (this.isBailleurSocial && this.filter.creationProgramme)) {
      if (this.filter.annonceParente) {
        this.rules.code_postal[0].required = false
        this.rules.code_postal_reel[0].required = false
        this.rules.ville_reelle[0].required = false
        this.rules.ville_contact_a_afficher[0].required = false
      } else {
        this.rules.prix[0].required = false
        this.rules.prix_min[0].required = false
      }
    }

    if (this.isUSH) {
      this.rules.nb_pieces_logement[0].required = true
    }
    if (this.universe === 'VO') {
      this.rules.code_postal[0].required = false
      if (this.rules.ville) {
        this.rules.ville[0].required = false
      }
      delete (this.post.communiquer_adresse_exacte)
    }
    if (!this.create) {
      this.$store.commit('donnees/SET_DEVISE', this.post.devise_iso_4217)
    } else {
      this.$store.commit('donnees/SET_DEVISE', 'EUR')
    }
    console.log(this.rules)
  },
  created () {
    // si on fait un changement de langue sur une page d'édition, les labels peuvent ne pas avoir le temps de
    // se charger. Le code suivant attend un peu avant d'afficher les components si besoin.
    if (this.$labels === undefined) {
      setTimeout(() => {
        this.labelsLoaded = true
      }, 4000)
    } else {
      this.labelsLoaded = true
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.redirectToList && this.redirect == false) {
      const answer = window.confirm(this.$t('posts.edit.alertBeforeLeave'))
      if (answer) {
        this.filter.creationProgramme = null
        next()
      }
      // } else {
      //     next(false)
      // }
    } else {
      next()
    }
  }
}
</script>
